<template>
<v-dialog v-model="dialog" scrollable max-width="980px" transition="dialog-transition" persistent :fullscreen="$vuetify.breakpoint.smAndDown" @keydown.esc="emitExit()">
    <v-card flat class="hotel-modal" id="hotel-geolocation">

        <v-card-title>
            <div class="pl-2 hotel-modal-header">
                {{ $t('hotel.modal.geolocation.title') }}
            </div>
            <v-spacer></v-spacer>
            <v-icon @click="emitExit()">close</v-icon>
        </v-card-title>
        <v-card-text class="scroll-card">
            <div>
                <div class="regular pa-2">
                    {{ $t('hotel.modal.geolocation.description') }}
                </div>
                <v-row>
                    <v-col offset-md="2" md="8" cols="12">{{ $t('hotel.geolocation.message_info') }}</v-col>
                </v-row>
                <v-row>
                    <v-col class="pl-3 py-2" cols="12">
                        <v-input prepend-icon="place" class="gmap-autocomplete">
                            <gmap-autocomplete :value="google_address" :options="center_position" @place_changed="setPlace($event)" class="form-control" :placeholder="$t('hotel.geolocation.search_placeholder')" style="width: 100%;">
                            </gmap-autocomplete>
                        </v-input>
                        <GmapMap :center="center_position" :zoom="15" map-type-id="terrain" style="width: 100%; height: 350px">
                            <GmapMarker v-model="center_position" :position="center_position" :clickable="true" :draggable="true" @dragend="setPlace2($event)" />
                        </GmapMap>
                    </v-col>
                </v-row>
            </div>
            <v-expand-transition>
                <div>
                    <div class="hotel-modal-title pl-2 pt-2">{{ $t('hotel.geolocation.address.title') }}</div>
                    <v-form v-model="valid" ref="hotel_location">
                        <v-row>
                            <v-col class="py-0" cols="6" md="3">
                                <v-autocomplete :label="$t('hotel.geolocation.address.country')" v-model="item.country_code" :items="config.countries" item-text="name" item-value="code" :menu-props="{transition:'scale-transition', 'offset-y': ''}"
                                    required :rules="rules.address_country" />
                            </v-col>
                            <v-col class="py-0" cols="6" md="3">
                                <v-text-field :label="$t('hotel.geolocation.address.region')" v-model="item.static.geo.region" required :rules="rules.address_state" />
                            </v-col>
                            <v-col class="py-0" xcols="2" md="6">
                                <v-text-field :label="$t('hotel.geolocation.address.city')" v-model="item.static.geo.city" required :rules="rules.address_city" />
                            </v-col>
                            <v-col class="py-0" cols="9" md="4">
                                <v-text-field :label="$t('hotel.geolocation.address.street')" v-model="item.static.geo.address" required :rules="rules.address_street" />
                            </v-col>
                            <v-col class="py-0" cols="3" md="2">
                                <v-text-field :label="$t('hotel.geolocation.address.number')" v-model="item.address.number" />
                            </v-col>
                            <v-col class="py-0" cols="9" md="4">
                                <v-text-field :label="$t('hotel.geolocation.address.building')" v-model="item.address.building" hint="Numele cladirii, nr. etaj, etc" />
                            </v-col>
                            <v-col class="py-0" cols="9" md="2">
                                <v-text-field :label="$t('hotel.geolocation.address.postcode')" v-model="item.static.geo.postcode" required :rules="rules.address_postal_code" />
                            </v-col>
                        </v-row>
                        <div class="hotel-modal-title pl-2 pt-1">{{$t('hotel.geolocation.title_details')}}</div>
                        <v-row>
                            <v-col class="py-0" cols="12" md="4">
                                <v-autocomplete :label="$t('hotel.geolocation.timezone')" v-model="item.static.defaults.timezone" :items="config.timezones" :rules="rules.timezone" required clearable
                                    :menu-props="{transition:'scale-transition', 'offset-y': ''}" />
                            </v-col>
                        </v-row>
                    </v-form>
                </div>
            </v-expand-transition>
        </v-card-text>
        <v-card-actions>
            <v-btn color="primary" @click="emitExit()">{{ $t('button.cancel') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" :loading="loading_save" @click="save()">{{ $t('button.save') }}</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
import {
    mapActions
} from "vuex";
import * as VueGoogleMaps from "vue2-google-maps";
import logger from '../../../../logger.js';
import Axios from "axios";

// instantiate axios
const axios = Axios.create();

export default {
    props: {
        dialog: Boolean,
        item: Object,
        config: Object
    },
    name: `item-hotel`,

    data() {
        return {
            valid: true,
            address: false,
            loading_save: false,
            timezones: [],
            google_address: null,
            center_position: {
                lat: Number(this.item.static.geo.lat),
                lng: Number(this.item.static.geo.lon)
            },
            original_center_position: {
                lat: Number(this.item.static.geo.lat),
                lng: Number(this.item.static.geo.lon)
            },
        };
    },

    watch: {
        item: {
            handler() {
                this.center_position = {
                    lat: Number(this.item.static.geo.lat),
                    lng: Number(this.item.static.geo.lon)
                }
            },
            deep: true
        },
    },

    computed: {
        rules() {
            return {
                address_country: [v => !!v || this.$t('hotel.geolocation.form_rules.country')],
                address_city: [v => !!v || this.$t('hotel.geolocation.form_rules.city')],
                address_state: [v => !!v || this.$t('hotel.geolocation.form_rules.state')],
                address_street: [v => !!v || this.$t('hotel.geolocation.form_rules.street')],
                address_number: [v => !!v || this.$t('hotel.geolocation.form_rules.number')],
                address_postal_code: [v => !!v || this.$t('hotel.geolocation.form_rules.postcode')],
                timezone: [v => !!v || this.$t('hotel.geolocation.form_rules.timezone')]
            }
        }
    },

    methods: {
        ...mapActions("alert", ["success", "error"]),

        setPlace(event_value) {
            this.address = true;
            this.center_position = {
                lat: event_value.latLng.lat(),
                lng: event_value.latLng.lng()
            };
            this.item.static.geo.lat = event_value.latLng.lat();
            this.item.static.geo.lon = event_value.latLng.lng();

            event_value.address_components.forEach(
                function (place) {
                    this.setAddressInfo(place);
                }.bind(this)
            );
        },

        setPlace2(event_value) {
            this.center_position = {
                lat: event_value.latLng.lat(),
                lng: event_value.latLng.lng()
            };
            this.item.static.geo.lat = event_value.latLng.lat();
            this.item.static.geo.lon = event_value.latLng.lng();

            axios.get("https://maps.googleapis.com/maps/api/geocode/json?latlng=" + event_value.latLng.lat() + "," + event_value.latLng.lng() + "&key=AIzaSyCu1N9tNE8mEh_u4yI3SCOn3M_gV3CgL5E")
                .then(response => {
                    response.data.results[0].address_components.forEach(
                        function (place) {
                            this.setAddressInfo(place);
                        }.bind(this)
                    );
                })
                .catch(error => {
                    logger.error(error.message, error.stack)
                        .then(() => null);
                    this.error(this.$t('hotel.geolocation.message_error_google'));
                    // this.errors.push(e)
                });
        },

        setAddressInfo(place) {
            place.types.forEach(function (item) {
                switch (item) {
                case "street_number":
                    this.item.address.number = place.long_name;
                    break;
                case "route":
                    this.item.static.geo.address = place.long_name;
                    break;
                case "locality":
                    this.item.static.geo.city = place.long_name;
                    break;
                    // case 'administrative_area_level_2':
                    // address.city = place.long_name;
                case "administrative_area_level_1":
                    this.item.static.geo.region = place.long_name;
                    break;
                case "country":
                    this.item.country_code = place.short_name;
                    break;
                case "postal_code":
                    this.item.static.geo.postcode = place.long_name;
                    break;
                }
            }.bind(this));
        },

        save() {
            this.loading_save = true;
            // prepare some data for saving
            let model = {
                country_code: this.item.country_code,
                static: {
                    defaults: {
                        timezone: this.item.static.defaults.timezone
                    },
                    geo: {
                        lat: this.item.static.geo.lat,
                        lon: this.item.static.geo.lon,
                        address: this.item.static.geo.address,
                        region: this.item.static.geo.region,
                        city: this.item.static.geo.city,
                        postcode: this.item.static.geo.postcode,
                    },
                }
            };
            if(this.item.address.number) {
                model.static.geo.address = this.item.static.geo.address + " nr." + this.item.address.number
            }
            if(this.item.address.building) {
                model.static.geo.address = this.item.static.geo.address + " " + this.item.address.building
            }
            let hotel = this.$clone(this.item);
            delete hotel.address;
            hotel.static.images = [];
            hotel.static.geo = model.static.geo;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/hotels/";

            this.$axios.put(endpoint + this.item.id, hotel)
                .then(response => {
                    this.$emit('update')
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                })
                .finally(() => {
                    this.loading_save = false;
                });
        },

        emitExit() {
            this.$emit('exit')
        }
    },
};
</script>
<style media="screen" lang="stylus">
.v-input
    &.gmap-autocomplete
        .v-input__slot
            input
                padding: 3px
                border-bottom: 1px solid #727e8c
                &:hover
                    border-bottom: 1px solid black
                &:focus
                    border-bottom: 1px solid black
        
</style>
